/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const StyleFleche = require('../types/StyleFleche')
const Vect = require('../types/Vect')
const kernel = require('../kernel/kernel')
const CMarqueAngleGeometrique = require('./CMarqueAngleGeometrique')
const CMarqueAngleOriente = require('./CMarqueAngleOriente')
module.exports = CMarqueAngleOrienteDirecte

/**
 * Classe représentant une marque d'angle orienté de sens direct.
 * @constructor
 * @extends CMarqueAngleOriente
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
 * @param {Boolean} estElementFinal : true si élément final de construction.
 * @param {mtg32.Color} couleur : La couleur.
 * @param {Boolean} masque : true si l'objet est masqué.
 * @param {mtg32.StleTrait} style : Donne le style trait utilisé.
 * @param {StyleMarqueAngle} styleMarque : Donne le style de la marque.
 * @param {Float} rayon : Le rayon de l'arc.
 * @param {CPt} a : Le premier point
 * @param {CPt} o : Le point sommet de l'angle définissant l'arc.
 * @param {CPt} b : Le troisième point.
 * @param {StyleFleche} motifFleche : Le style utilisé pour la flèche finissant l'arc.
 * @returns {CMarqueAngleOrienteDirecte}
 */
function CMarqueAngleOrienteDirecte (listeProprietaire, impProto, estElementFinal, couleur, masque,
    style, styleMarque, rayon, a, o, b, motifFleche){
  if (arguments.length === 1) CMarqueAngleOriente.call(this, listeProprietaire);
  else {
    CMarqueAngleOriente.call(this, listeProprietaire, impProto, estElementFinal, couleur,
      masque, style, styleMarque, rayon, a, o, b);
    this.motifFleche = motifFleche;
  }
}
CMarqueAngleOrienteDirecte.prototype = new CMarqueAngleOriente();
CMarqueAngleOrienteDirecte.prototype.constructor = CMarqueAngleOrienteDirecte;
CMarqueAngleOrienteDirecte.prototype.superClass = "CMarqueAngleOriente";
CMarqueAngleOrienteDirecte.prototype.className = "CMarqueAngleOrienteDirecte";

CMarqueAngleOrienteDirecte.prototype.getClone = function(listeSource, listeCible) {
  var ind1 = listeSource.indexOf(this.a);
  var ind2 = listeSource.indexOf(this.o);
  var ind3 = listeSource.indexOf(this.b);
  var ind4 = listeSource.indexOf(this.impProto);
  return new CMarqueAngleOrienteDirecte(listeCible, listeCible.get(ind4, "CImplementationProto"),
    this.estElementFinal, this.couleur, this.masque, this.style, this.styleMarque, this.rayon,
    listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"), listeCible.get(ind3, "CPt"),this.motifFleche,);
};
CMarqueAngleOrienteDirecte.prototype.positionne = function(infoRandom, dimfen) {
  var petitAngle,longueurFleche;
  // Ici ne pas appeler la fonction de l'ancêtre direct
  CMarqueAngleGeometrique.prototype.positionne.call(this, infoRandom, dimfen);
  if (!this.existe) return;
  // Optimisation pour la version 1.9.5
  longueurFleche = StyleFleche.longeurFlechePourArc(this.motifFleche, this.listeProprietaire);
  this.v.vecteurColineaire(this.rayon,this.v0);
  this.angle = this.u.mesureAngleVecteurs(this.v);
  if (kernel.zeroAngle(this.angle - Math.PI/2)) petitAngle = 0;
  // Modifié version 5.3. Meilleur quand la marque est petite
  // else petitAngle = longueurFleche/this.rayon;
  else petitAngle = Math.atan(longueurFleche/this.rayon/2);
  if (kernel.zero(this.angle)){
    this.existe = false;
    return;
  }
  else{
    this.v0.tourne(-Math.PI/2-petitAngle,this.vecteurDirection);
  }
  this.xdeb = this.o.x + this.v0.x;
  this.ydeb = this.o.y + this.v0.y;
};
CMarqueAngleOrienteDirecte.prototype.anglePourArc = function() {
  return (this.angle >= 0) ? this.angle : 2*Math.PI + this.angle;
};
CMarqueAngleOrienteDirecte.prototype.path = function(mesang) {
  var u1,v1,xo,yo,xf,yf;
  u1 = new Vect();
  this.u.vecteurColineaire(this.rayon, u1);
  v1 = new Vect();
  this.v.vecteurColineaire(this.rayon, v1);
  xo = this.centre_x + u1.x;
  yo = this.centre_y + u1.y;
  xf = this.centre_x + v1.x;
  yf = this.centre_y + v1.y;
  var largearcflag = (this.angle >= 0) ? "0 " : "1 ";
  return "M " + xo.toString() + " " + yo + "A" +  this.rayon + ","
    + this.rayon + " 0 " + largearcflag + " 0 " + xf.toString() +"," + yf.toString();
};



// WEBPACK FOOTER //
// ./src/objets/CMarqueAngleOrienteDirecte.js